export interface LayoutBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface TableAndChairsLayout {
  table: LayoutBox;
  chairs: (LayoutBox & { mirroredY: boolean })[];
}

export const tableAndChairsLayout = (
  width: number,
  height: number
): TableAndChairsLayout => {
  const chairSize = Math.min(width * 0.372, height * 0.278);
  const chairGap = height * 0.027;
  const chairXs = [width * 0.25, width * 0.75].map(
    (center) => center - chairSize / 2
  );

  return {
    table: {
      x: 0,
      y: chairSize + chairGap,
      width,
      height: height - 2 * (chairSize + chairGap),
    },
    chairs: chairXs.flatMap((x) => [
      { x, y: 0, width: chairSize, height: chairSize, mirroredY: false },
      {
        x,
        y: height - chairSize,
        width: chairSize,
        height: chairSize,
        mirroredY: true,
      },
    ]),
  };
};
